import SafetyService from '@/services/safety.service';

export default {
	state: {
		markerCreate: false,
		newSelector: {
			name: null,
			value: {
				id: null,
				value: null
			}
		},
		factoringData: []
	},
	getters: {
		getMarkerCreate(state) {
			return state.markerCreate;
		},
		getNewSelector(state) {
			return state.newSelector;
		}
	},
	mutations: {
		SET_MARKER(state, payload) {
			state.markerCreate = payload;
		},
		SET_NEW_SELECTOR(state, payload) {
			state.newSelector = payload;
		},
		SET_FACTORING_LIST(state, payload) {
			state.factoringData = [];
			state.factoringData = payload;
		},
	},
	actions: {
		setNewSelector({ commit }, payload) {
			commit('SET_NEW_SELECTOR', payload);
		},
		addItem({ commit }, payload) {
			commit('SET_MARKER', payload);
		},
		async saveDriver(context, payload) {
			return await SafetyService.saveDriver(payload).then((result) => {
				return result;
			}).catch((err) => {
				return err;
			});
		},
		async updateDriver(context, payload) {
			return await SafetyService.updateDriver(payload).then((result) => {
				return result;
			}).catch((err) => {
				return err;
			});
		},
		async deleteDriver(context, payload) {
			return await SafetyService.deleteDriver(payload).then((result) => {
				return result;
			}).catch((err) => {
				return err;
			});
		},
		async getTruck(context, payload) {
			return await SafetyService.getTruck(payload).then((result) => {
				if (result.status != false) {
					return result;
				}
			}).catch((err) => {
				return err;
			});
		},
		async saveTruck(context, payload) {
			return await SafetyService.saveTruck(payload).then((result) => {
				return result;
			}).catch((err) => {
				return err;
			});
		},
		async updateTruck(context, payload) {
			return await SafetyService.updateTruck(payload).then((result) => {
				return result;
			}).catch((err) => {
				return err;
			});
		},
		async deleteTruck(context, payload) {
			return await SafetyService.deleteTruck(payload).then((result) => {
				return result;
			}).catch((err) => {
				return err;
			});
		},
		async getTrailer(context, payload) {
			return await SafetyService.getTrailer(payload).then((result) => {
				if (result.status != false) {
					return result;
				}
			}).catch((err) => {
				return err;
			});
		},
		async saveTrailer(context, payload) {
			return await SafetyService.saveTrailer(payload).then((result) => {
				return result;
			}).catch((err) => {
				return err;
			});
		},
		async updateTrailer(context, payload) {
			return await SafetyService.updateTrailer(payload).then((result) => {
				return result;
			}).catch((err) => {
				return err;
			});
		},
		async deleteTrailer(context, payload) {
			return await SafetyService.deleteTrailer(payload).then((result) => {
				return result;
			}).catch((err) => {
				return err;
			});
		},
		async getCustomer(context, payload) {
			return await SafetyService.getCustomer(payload).then((result) => {
				if (result.status != false) {
					return result;
				}
			}).catch((err) => {
				return err;
			});
		},
		async saveCustomer(context, payload) {
			return await SafetyService.saveCustomer(payload).then((result) => {
				return result;
			}).catch((err) => {
				return err;
			});
		},
		async updateCustomer(context, payload) {
			return await SafetyService.updateCustomer(payload).then((result) => {
				return result;
			}).catch((err) => {
				return err;
			});
		},
		async deleteCustomer(context, payload) {
			return await SafetyService.deleteCustomer(payload).then((result) => {
				return result;
			}).catch((err) => {
				return err;
			});
		},
		async getEmployee(context, payload) {
			return await SafetyService.getEmployee(payload).then((result) => {
				if (result.status != false) {
					return result;
				}
			}).catch((err) => {
				return err;
			});
		},
		async createEmployee() {
			return await SafetyService.createEmployee().then((result) => {
				if (result.status != false) {
					return result;
				}
			}).catch((err) => {
				return err;
			});
		},
		async saveEmployee(context, payload) {
			return await SafetyService.saveEmployee(payload).then((result) => {
				return result;
			}).catch((err) => {
				return err;
			});
		},
		async updateEmployee(context, payload) {
			return await SafetyService.updateEmployee(payload).then((result) => {
				return result;
			}).catch((err) => {
				return err;
			});
		},
		async deleteEmployee(context, payload) {
			return await SafetyService.deleteEmployee(payload).then((result) => {
				return result;
			}).catch((err) => {
				return err;
			});
		},
		async getGeneralData() {
			return await SafetyService.getGeneralData();
		},
		async getGeneralCustomers(context, payload) {
			return await SafetyService.getGeneralCustomers(payload);
		},
		async setGeneralData(context, payload) {
			return await SafetyService.setGeneralData(payload);
		},
	}
};
